<template>
    <div class='container-fluid'>
      <b-row>
        <b-nav class="admin-sub-nav" pills>
          <b-nav-item v-for="jotform in jotforms" :key="jotform.id" :to="{name: 'Jotform', params: {id: jotform.id}}" @click="selectJotform(jotform.id)" action>
            {{ jotform.name }}
          </b-nav-item>
          <b-nav-item :to="{name: 'JotformNew'}" @click="setBlankJotform" action>+</b-nav-item>
        </b-nav>
        <router-view :jotform="jotform" :jotforms="jotforms" v-on:submit-successful="allJotforms"/>
      </b-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AdminJotform from './Show'
import {jotformMixins} from '@/mixins/jotformMixins'
export default {
  name: 'AdminJotformsIndex',
  mixins: [jotformMixins],
  data () {
    return {
      jotforms: [],
      jotform: {}
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },

  created () {
    this.allJotforms()
  },

  methods: {
  },
  components: {
    AdminJotform
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/jotforms/Index.vue